import { useNavigate } from "react-router-dom";
import useDealList from "../../../../api/hooks/use-deal-list";
import Button from "../../../ui/button";
import DealList from "./components/deal/dealList";
import styles from "./styles.module.scss";
import { PATHS, TILDA_PATHS } from "../../../shared/constants";

const UserDeal = () => {
  const { dealList, mutate } = useDealList();

  const navigate = useNavigate();

  const handleRefetch = () => {
    mutate();
  };

  return (
    <div className={styles.deals}>
      <div className={styles.deals__container}>
        <div className={styles.deals__title}>
          {dealList.length > 0
            ? "Список текущих заявок:"
            : " Вы не отправили еще ни одной заявки в компанию Reit. Можете начать уже сейчас:"}
        </div>
        <div className={styles.deals__list}>
          {dealList.length > 0 ? (
            <DealList deals={dealList} onRefetch={handleRefetch} />
          ) : (
            <div className={styles.deals__noDeals}>
              <Button
                label="Квартиры в наличии"
                variant="dark"
                onClick={() =>
                  window.open(TILDA_PATHS.reitInvest.reitFacility, "_blank")
                }
              />
              <Button
                label="ТРЕЙД-ИН"
                variant="dark"
                onClick={() =>
                  window.open(TILDA_PATHS.reitInvest.tradeIn, "_blank")
                }
              />
              <Button
                label="Оценка"
                variant="dark"
                onClick={() =>
                  window.open(TILDA_PATHS.reitInvest.estimate, "_blank")
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDeal;
